module.exports = __webpack_public_path__ + "static/img/facilities-text-1.12da9c7d.jpg";